import { FirmsDirectoryContainer } from "@/features/platform-admin/containers/firms-directory-container";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/firms")({
  component: FirmsDirectoryContainer,
});
